import { unionBy } from 'lodash';
import type { AssetTypename, TypePolicies } from '../../../utils';

/** the assets that support field values */
const assetsWithFields: [...AssetTypename[]] = [
  'AudioAsset',
  'DocumentAsset',
  'FileAsset',
  'ImageAsset',
  'InteractiveAsset',
  'InteractiveLiveAsset',
  'ModelAsset',
  'UnsupportedAsset',
  'VersionStackAsset',
  'VideoAsset',
] as const;

/** policies exclusive to assets with fieldValues */
const fieldsPolicies = assetsWithFields.reduce(
  (acc, name) => ({
    ...acc,
    [name]: {
      fields: {
        fieldValues: {
          keyArgs: false,
        },
        fieldValuesNew: {
          keyArgs: false,
          /**
           * Merging fieldValuesNew so that we don't remove field values that
           * were previously fetched in case a new query requests different
           * fields than previous queries. Manually merging since merge: true
           * isn't merging the nested nodes field correctly.
           */
          merge(existing, incoming, { readField }) {
            if (!existing && !incoming) {
              return {
                nodes: [],
                totalCount: 0,
              };
            }
            if (existing && !incoming) return existing;

            const nodes = unionBy(
              (existing?.nodes ?? []) as [],
              (incoming.nodes ?? []) as [],
              (node: any) => readField('id', node)
            );

            return {
              ...existing,
              ...incoming,
              nodes,
            };
          },
        },
      },
    } satisfies TypePolicies['VideoAsset'],
  }),
  {}
);

export const typePolicies: TypePolicies = {
  AssetFieldValue: {
    fields: {
      value: {
        merge: false,
      },
    },
  },
  ...fieldsPolicies,
};
